/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A customer-supplied model provider API key bound to a project and responsibility slot. Key material is write-only and never returned.
 */
export type ModelProviderKey = {
  /**
   * ISO 8601 timestamp when the key was created.
   */
  createdAt: Date;
  /**
   * Whether the key participates in key resolution.
   */
  enabled: boolean;
  /**
   * The ID of the key
   */
  id: string;
  /**
   * The project the key belongs to
   */
  projectId: string;
  /**
   * The model provider the key authenticates with. Supported values include openrouter.
   */
  provider: string;
  /**
   * The responsibility slot the key applies to. The 'default' slot covers every slot without a dedicated override.
   */
  slot: string;
  /**
   * ISO 8601 timestamp of the most recent change.
   */
  updatedAt: Date;
};

/** @internal */
export const ModelProviderKey$inboundSchema: z.ZodMiniType<
  ModelProviderKey,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    enabled: z.boolean(),
    id: z.string(),
    project_id: z.string(),
    provider: z.string(),
    slot: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function modelProviderKeyFromJSON(
  jsonString: string,
): SafeParseResult<ModelProviderKey, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ModelProviderKey$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ModelProviderKey' from JSON`,
  );
}
